export default {"src":"/_next/static/media/left.82a4ad38.svg","height":159,"width":115};